import React, { FC, useState } from "react";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { getControllers } from "../../../../services/controllerService";
import ControllerColumns from "../../../../models/ColumnDefinitions/ControllerColumns";
import ControllerSearch from "../../../../models/search/ControllerSearch";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import TableTab from "../../../tabs/table-tab";
import { useLocale } from "../../../../contexts/localeContext";
import { hideColumns } from "../../../../models/utilities/columnHelper";
import { useFormikContext } from "formik";

interface ControllerEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const ControllerEntity: FC<ControllerEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const {setFieldValue} = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds([...selectedIds]);
    }  

    return <div className="pt-3 pr-3 pl-3 h-full">
        <TableContextProvider
            dataMethod={getControllers}
            useTable
            usePagination
            useFilter
            useSearch
            useSort
            tableDescriptor={hideColumns(ControllerColumns, ["type", "preset", "queue"])}
            searchDescriptor={ControllerSearch}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.controller)}
                selectRows={true}
                selectedIds={selectIds}
                setSelectedIds={onSelectedIds}
                tableId={'controllerEntity'}
                cyName="controllerEntity">
            </TableTab>
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="button"
                    onClick={e => onNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default ControllerEntity;